export default __webpack_public_path__ + "static/media/53.1d13fdfc.jpg";